<script lang="ts" setup>
definePageMeta({
  middleware: "auth",
  auth: {
    anonymousOnly: true,
    redirectAuthenticatedTo: "/",
  },
});
</script>

<template>
  <div class="my-3xl">
    <CenterCard view-mode="narrow">
      <FormAuthLogin />
    </CenterCard>
  </div>
</template>

<style scoped>

</style>
